import { mainIconSize } from '@/constants';
import { UserManagementTable } from '@/pages/Studies/components';
import { Study } from '@/types';
import { type ButtonProps, Dialog } from '@nautilusbio/nb-design-system';
import { getTextClassName } from '@nautilusbio/nb-design-system/helpers';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Link } from '@tanstack/react-router';
import clsx from 'clsx';
import { TFunction } from 'i18next';
import { UserCog2 } from 'lucide-react';
import React, { FC } from 'react';

import styles from '../styles.module.css';

interface StudyTitleBarProps {
  studyStyles: { [key: string]: string };
  pageStyles: { [key: string]: string };
  t: TFunction<'studies', undefined>;
  data?: Study;
  orgId: string;
  studyId: string;
  isOwner: boolean;
}

const dialogClassNames = { content: styles.dialogContent };

export const StudyTitleBar: FC<StudyTitleBarProps> = ({
  studyStyles,
  pageStyles,
  t,
  data,
  orgId,
  studyId,
  isOwner,
}) => {
  const triggerProps: Omit<ButtonProps, 'data-testid'> = {
    children: (
      <>
        <UserCog2 size={mainIconSize} />
        {t('study.manage_users')}
      </>
    ),
    className: studyStyles.manageUsersBtn,
    size: 'md' as const,
    visual: 'unstyled' as const,
  };

  return (
    <Stack
      className={clsx(pageStyles.titleRow, pageStyles.organizationTitle, studyStyles.studyTitleBar)}
      fullWidth
      justifyContent="space-between"
      orientation="horizontal"
    >
      <Link activeOptions={{ exact: true }} className={getTextClassName('lg')} to="/studies">
        {t('study.back')}
      </Link>

      {data && (
        <Dialog
          classNames={dialogClassNames}
          content={
            <UserManagementTable
              allowedUsers={data.allowed_users ?? []}
              canManage={isOwner}
              orgId={orgId}
              studyId={studyId}
            />
          }
          data-testid={'manage-users'}
          maxWidth="800px"
          title={t('study.manage_users')}
          triggerProps={triggerProps}
        />
      )}
    </Stack>
  );
};
